import { ReactNode, useId } from "react";
import { Box, Typography } from "@mui/material";
import SysColumn from "app/class/sys-column";
import { useTranslation } from "react-i18next";
import { translateMetadataLabel } from "modules/record/shared/services/recordMetadataLabels";

export interface BaseFieldProps {
    column: SysColumn;
    children: ReactNode | ((headerId: string) => ReactNode);
    hidden?: boolean;
    required?: boolean;
    removeHeader?: boolean;
    as?: "label" | "group";
}

export const BaseField = ({ column, children, hidden, required, removeHeader = false, as = "label" }: BaseFieldProps) => {
    const { t } = useTranslation();
    const headerId = useId();

    if (hidden) return null;

    return (
        <Box component={as === "group" ? "div" : "label"} role={as === "group" ? "group" : undefined} aria-labelledby={as === "group" && !removeHeader ? headerId : undefined}>
            {removeHeader === false && (
                <Typography variant="subtitle2" id={headerId}>
                    {translateMetadataLabel(t, column)}
                    {(required ?? column.is_mandatory) && (
                        <Box component="span" sx={{ color: (theme) => theme.palette.mode === "dark" ? "#FF8A80" : theme.palette.error.dark }}> *</Box>
                    )}
                </Typography>
            )}
            {typeof children === "function" ? children(headerId) : children}
        </Box>
    );
};
